import React from 'react';
import { motion } from 'framer-motion';
import { tomos } from '../data/content';
export function TomosSection() {
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-236" data-mp="1kbix5k4ofekq">
      <div className="mx-auto max-w-5xl" data-id="element-237" data-mp="1p3ttkd07ki8j">
        <div className="mx-auto max-w-2xl text-center" data-id="element-238" data-mp="1p43p0g40vhlm">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-slate sm:text-4xl" data-id="element-239" data-mp="1u36id3an3zdr">
            6 Complete Clinical Volumes
          </h2>
          <p className="mt-3 text-sm text-slate/70 sm:text-base" data-id="element-240" data-mp="xe7c1ttm97o7">
            Evidence-based content for every area of your professional practice
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-241" data-mp="16cav8jh4pscu">
          {tomos.map((tomo, i) => <motion.article key={tomo.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex gap-4 rounded-2xl border border-sage/25 bg-white p-5 shadow-sm shadow-sage/5 sm:gap-6 sm:p-7" data-id="element-242" data-mp="1bd6v8lyd0ucz" data-mpi={i}>
              <div className="min-w-0 flex flex-1" data-id="element-243" data-mp="2mneuglvlw5nn">
                <div className="flex flex-col" data-id="element-244" data-mp="2hmr7qceeuaz8">
                  <span className="font-serif-display text-3xl font-bold leading-none text-sage sm:text-4xl" data-id="element-245" data-mp="2hpn621u671o7">
                    {tomo.number}
                  </span>
                  <h3 className="mt-3 text-base font-bold leading-snug text-slate sm:text-lg" data-id="element-246" data-mp="27q61xoukgvuc">
                    {tomo.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-slate/70" data-id="element-247" data-mp="1yx2goudojep5">
                    {tomo.description}
                  </p>
                  <span className="mt-5 inline-block w-fit rounded-full bg-sage/10 px-3 py-1 text-xs font-medium text-dark-green" data-id="element-248" data-mp="1tz10qibjvvhw">
                    {tomo.tag}
                  </span>
                </div>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-sage/10 p-1.5" data-id="element-249" data-mp="1k0k1ky2gkakr">
                <img src={tomo.coverImage} alt={`Cover of Volume ${tomo.number}: ${tomo.title}`} loading="lazy" className="block h-[132px] w-[88px] rounded-lg object-cover shadow-[0_8px_16px_-7px_rgba(61,61,61,0.38)] sm:h-[162px] sm:w-[108px]" data-id="element-250" data-mp="1abegbw4wma6b" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}